/**
 * Custom element tag names only (generated). Safe for ComponentRegistryService imports.
 * Regenerate: node tools/generate-custom-elements-definitions.mjs
 */
export const ALL_CUSTOM_ELEMENT_TAGS: ReadonlySet<string> = new Set<string>([
  'gtw-screen-video-container-ce',
  'gtw-entity-chart-update-ce',
  'gtw-home-page-ce',
  'gtw-header-ce',
  'gtw-footer-ce',
  'gtw-screen-ce',
  'gtw-navigation-ce',
  'gtw-ghost-console-ce',
  'gtw-efile-submission',
  'gtw-efile-upload-irs-schema',
  'gtw-statement-tracker',
  'dst-custom-report',
  'gtw-sec351-report',
  'gtw-sec332-report',
  'gtw-sec368-report',
  'gtw-sec926-report',
  'gtw-form8594-report',
  'gtw-form8883-report',
  'gtw-na-report',
  'gtw-data-collect-report',
  'gtw-transfers-review-report',
  'gtw-dups-stmt-report',
  'gtw-f304-diag-report',
  'gtw-screen-documents-ce',
  'gtw-release-notes-ce',
  'gtw-mef-efile-changes',
  'gtw-form-8082',
  'gtw-related-party-change-system-acct-ce',
  'gtw-related-party-insert-category-ce',
  'gtw-related-party-payment-type-ce',
  'gtw-related-party-payment-add-ce',
  'gtw-related-party-payment-delete-ce',
  'gtw-related-party-payment-allocation-ce',
  'gtw-m3-payor-allocate-ce',
  'gtw-f8865-sch-m2-k1-sourcing',
  'gtw-supplemental-info-ce',
  'gtw-naics-maintenance',
  'gtw-entity-chart-map-clean-up',
  'gtw-detail-diagnostic-ce',
  'gtw-summary-diagnostic-ce',
  'gtw-pship-spl-alloc',
  'gtw-sourcing-default-me-ce',
  'gtw-sourcing-amounts',
  'gtw-spotrates-all-curr-sync-ce',
  'gtw-fx_amt-sync-ce',
  'gtw-batch-sourcing-default-me-ce',
  'gtw-dashboard-filter-ce',
  'gtw-count-by-business',
  'gtw-diagnostics-report',
  'gtw-fir-tested-units-sync-ce',
  'gtw-ghost-update-combination-ce',
  'gtw-f1118-schd-c-ce',
  'gtw-rd-sales-adjustment-ce',
  'gtw-cfc-investment-adj-edit-ce',
  'gtw-cfc-split-on-owner-percent-edit-ce',
  'gtw-ftc-comments-ce',
  'gtw-asset-rollover-ce',
  'gtw-exams-rollover-ce',
  'gtw-coa-diagnostic-fix-ce',
  'gtw-component-defaults-rollover-ce',
  'gtw-rd-sales-adj-percentage-edit-ce',
  'gtw-rd-sales-adj-percentage-add-ce',
  'gtw-config-861-ce',
  'gtw-config-861-add-ce',
  'gtw-form-1118-config-ce',
  'gtw-form-1118-sync-ce',
  'gtw-trans-catg-sync-ce',
  'gtw-htko-config-ce',
  'gtw-k2-k3-sync-config-ce',
  'gtw-k2-sync-ce',
  'gtw-pship-ptr-ce',
  'gtw-fir-edit-gtaps-attributes-ce',
  'gtw-fx_rates-sync-ce',
  'gtw-sourcing-project-tagging-ce',
  'gtw-disregarded-entities',
  'gtw-s3-file-upload-ce',
  'gtw-domestic-project-tagging-ce',
  'gtw-partnership-dashboard-ce',
  'gtw-df-mapping-changes-ce',
  'gtw-admin-actions-ce',
  'gtw-admin-action-edit-ce',
  'gtw-fir-f5471-h1-ce',
  'gtw-cbc-beps-categories-ce',
  'gtw-cbc-beps-quarters-ce',
  'gtw-df-assign-entity-ce',
  'gtw-fir-overrides163j-ce',
  'gtw-settlement-redirection-ce',
  'gtw-cbc-beps-countries-ce',
  'gtw-efile-review-attachments-ce',
  'gtw-posting-partners-ce',
  'gtw-pdf-review-diagnostics-ce',
  'gtw-process-5713-lines-ce',
  'gtw-efile-edit-key-table-data-ce',
  'gtw-dst-efile-datapush-ce',
  'gtw-dst-efile-pdf-push-ce',
  'gtw-user-access-request-ce',
  'gtw-user-access-approval-ce',
  'gtw-user-onboarding-ce',
  'gtw-form-1065-m2-ce',
  'gtw-fir-form-regen-ce',
  'gtw-fir-ghost-ownership-ce',
  'gtw-fir-ghost-sourcing-ce',
  'gtw-fir-qbu-sourcing-delete-record-ce',
  'gtw-ghost-ownership-info-delete-ce',
  'gtw-ghostc-nonghost-delete-ce',
  'gtw-ghost-settlement-reclasses-delete-ce',
  'gtw-ghost-usdbasispti-nonghost-delete-ce',
  'gtw-ghost-ftce-nonghost-delete-ce',
  'gtw-ghost-earnprofit-nonghost-delete-ce',
  'gtw-fir-163j-tagging-ce',
  'gtw-fir-163j-default-system-tagging-ce',
  'gtw-fir-163j-reset-default-tagging-ce',
  'gtw-fir-163j-sync-to-8990-ce',
  'gtw-fir-5471-schedule-m-ce',
  'gtw-fir-5471-schedule-i-ce',
  'gtw-fir-5471-schedule-f-ce',
  'gtw-fir-5471-schedule-e-ce',
  'gtw-fir-5471-schedule-j-ce',
  'gtw-fir-sys-form-chart-acct-map-ce',
  'gtw-fir-sanctioned-countries-ce',
  'gtw-form5471-textinfo-ce',
  'gtw-form5471-schedule-g-ce',
  'gtw-form5471-schedule-i-ce',
  'gtw-schedule-d-adj-ce',
  'gtw-section174-adj-ce',
  'gtw-pdf-data-delete-ce',
  'gtw-fir-5471-schedule-g1-ce',
  'gtw-fir-8858-schedule-m-ce',
  'gtw-f1120-sch-m2-ce',
  'gtw-1120-subconsol-ce',
  'gtw-163j-reclass-trigger-ce',
  'gtw-163j-auto-ep-ce',
  'gtw-f163j-schd-a-data-refresh-ce',
  'gtw-alloc-batch-rerun-ce',
  'gtw-f8916-ce',
  'gtw-f8916-lim-ce',
  'gtw-batch-allocate-ce',
  'gtw-ext-entity-maintenance-ce',
  'gtw-entity-classification-create-ce',
  'gtw-entity-classification-update-ce',
  'gtw-f7004-ce',
  'gtw-f8964-ele-ce',
  'gtw-f3800-piii-consol-ce',
  'gtw-f1125-sch-e-ce',
  'gtw-f1125-sch-a-ce',
  'gtw-f1065-sch-c-ce',
  'gtw-f1065-sch-b2-ce',
  'gtw-f1065-page-one-ce',
  'gtw-foot-notes-ce',
  'gtw-f1065-sch-k-ce',
  'gtw-f1065-sch-k1-ce',
  'gtw-f1065-sch-m3-ce',
  'gtw-f1065-sch-b-ce',
  'gtw-f1120-sch-n-ce',
  'gtw-f1120-sch-k-ce',
  'gtw-f1120-sch-b-ce',
  'gtw-f1120-sch-m3-ce',
  'gtw-f1120-sch-m2-retained-earnings-ce',
  'gtw-f1120-sch-j-ce',
  'gtw-f1120pc-sch-e-ce',
  'gtw-f1120pc-sch-c-ce',
  'gtw-f1120pc-sch-i-ce',
  'gtw-f1120pc-sch-f-ce',
  'gtw-f1120l-sch-a-ce',
  'gtw-f1120l-sch-b-ce',
  'gtw-f1120l-sch-f-ce',
  'gtw-f1120l-sch-l-ce',
  'gtw-f1120l-sch-g-ce',
  'gtw-f1120l-sch-m-ce',
  'gtw-f1120-schc-line22-ce',
  'gtw-max-loan-delete-ce',
  'gtw-f965b-ce',
  'gtw-f4626-ce',
  'gtw-config851-data-ce',
  'gtw-batch-request-ce',
  'gtw-fir-5471-schedule-o-ce',
  'gtw-fir-8865-schedule-o-ce',
  'gtw-fir-fdii-qbai-exclude-acct-ce',
  'gtw-f1120-l-pc-headers-ce',
  'gtw-ec-configuration-ce',
  'gtw-scenario-setup-ce',
  'gtw-entity-filling-ce',
  'gtw-ec-quartermap-ce',
  'gtw-ec-refresh-setup-ce',
  'gtw-ec-threshold-setup-ce',
  'gtw-ec-threshold-delete-ce',
  'gtw-f8865-schd-k-ce',
  'gtw-f8858-schd-c1-ce',
  'gtw-basket-post-ce',
  'gtw-basket-post-delete-ce',
  'gtw-fir-163j-sync-ce',
  'gtw-cfc-group-elect-ce',
  'gtw-consol-group-ce',
  'gtw-amended-cycle-ce',
  'gtw-batch-monitoring-ce',
  'gtw-consolidation-ledgers-ce',
  'gtw-wwni-mapping-ce',
  'gtw-tax-attributes-ce',
  'gtw-wwni-sub-category-ce',
  'gtw-credit-details-ce',
  'gtw-batch-open-amended-ce',
  'gtw-fir-ep-bump-ce',
  'gtw-fir-local-acct-desc-ce',
  'gtw-fir-local-sys-chart-acct-map-ce',
  'gtw-project-delete-modal-ce',
  'gtw-mark-as-reviewed-ce',
  'gtw-assign-preparer-ce',
  'gtw-recurring-ep-ce',
  'gtw-recurring-multi-year-tax-adjustment-ce',
  'gtw-aggregration-rerun-ce',
  'gtw-update-change-list-ce',
  'gtw-update-document-detail-ce',
  'gtw-exclusion-list-ce',
  'gtw-maintenance-owner-ce',
  'gtw-maintenance-owner-delete-ce',
  'gtw-reference-table-ce',
  'gtw-partner-maintenance-ce',
  'gtw-partner-alloc-ce',
  'gtw-partner-alloc-new-ce',
  'gtw-pship-code-mast-ce',
  'gtw-default-sourcing-ce',
  'gtw-appr-config-ce',
  'gtw-entity-details-ce',
  'gtw-admin-scenario-setup-ce',
  'gtw-tbl-maintenance-ce',
  'gtw-delta-posting-ce',
  'gtw-local-chart-delete-ce',
  'gtw-dcs-ghost-settlement-ce',
  'gtw-f-4562-ce',
  'gtw-f-4626-ce',
  'gtw-f-8824-ce',
  'gtw-f-6252-ce',
  'gtw-beat-type-consol-add-ce',
  'gtw-review-adj-automation-ce',
  'gtw-section-details-ce',
  'gtw-f-schdd-ce',
  'gtw-calcs-scenario-data-setup-ce',
  'gtw-calcs-filing-group-status-ce',
  'gtw-f-4797-ce',
  'gtw-pdf-form-order-ce',
  'gtw-fir-trueup-taxes-ce',
  'gtw-trueup905c-comments-ce',
  'gtw-local-sys-chart-acct-map-delete-ce',
  'gtw-gl-local-acct-desc-ce',
  'gtw-f-7205-ce',
  'gtw-fir-8865-schedule-p-ce',
  'gtw-form8865-textual-ce',
  'gtw-related-party-modal-ce',
  'gtw-fir-repoint-ce',
  'gtw-ic-diagnostics-ce',
  'gtw-rd-exp-contributed-ce',
  'gtw-int-exp-contributed-ce',
  'gtw-issue-add-ce',
  'gtw-issue-edit-ce',
  'gtw-issue-management-list-ce',
  'gtw-f8865-schd-k1-ce',
  'gtw-branch-tax-creditable-edit-ce',
  'gtw-branch-tax-creditable-add-ce',
  'gtw-withhold-tax-summary-edit-ce',
  'gtw-branch-and-withhold-comment-ce',
  'gtw-branchtax-summary-info-ce',
  'gtw-tax-liability-dashboard-ce',
  'gtw-investment-validation-ce',
  'gtw-sourcing-asset-adjustment-ce',
  'gtw-track-untrack-sch-l-ce',
  'gtw-slt-data-service-request-ce',
  'gtw-sourcing-input-app-basket-ce',
  'gtw-reportable-transaction-ce',
  'gtw-form-1118-ftc-edit-ce',
  'gtw-slt-data-service-ce',
  'gtw-f1118-hp-ii-attach-schd-ce',
  'gtw-consol-group-edit-ce',
  'gtw-f1118-attach-schd-ce',
  'gtw-slt-add-data-service-ce',
  'gtw-method-settlement-ce',
  'gtw-gof-settlement-ce',
  'gtw-dashboard-901m-ce',
  'gtw-business-sign-off-ce',
  'gtw-project-review-ce',
  'gtw-retrigger-group-sync-ce',
  'gtw-slt-api-response-ce',
  'gtw-me-sic-assignment-ce',
  'gtw-slt-data-generation-ce',
  'gtw-slt-is-duplicate-ce',
  'gtw-slt-key-setup-ce',
  'gtw-expense-trans-add-edit-ce',
  'gtw-expense-trans-account-details-ce',
  'gtw-expense-trans-info-ce',
  'gtw-slt-sync-error-ce',
  'gtw-efile-submission-manifest-table-ce',
  'gtw-efile-edit-submission-table-data-ce',
  'gtw-external-state-entity-edit-ce',
  'gtw-external-state-entity-delete-ce',
  'gtw-expense-consol-config-ce',
  'gtw-form-8858-textualinfo-ce',
  'gtw-ftc-documentation-ce',
  'gtw-other-overrides-delete-ce',
  'gtw-other-overrides-batch-delete-ce',
  'gtw-state-group-add-ce',
  'gtw-state-group-edit-ce',
  'gtw-state-group-delete-ce',
  'gtw-state-group-assign-ce',
  'gtw-non-financial-direct-owner-ce',
  'gtw-non-financial-tax-owner-ce',
  'gtw-add-schdm-template-id-ce',
  'gtw-change-log-monitor-ce',
  'gtw-copy-legacy-files-ce',
  'gtw-entity-update-ce',
  'gtw-f1065-k2-p3s4-ce',
  'gtw-f1065-k2-p7s1-ce',
  'gtw-f1065-k2-p7s2-ce',
  'gtw-f1065-k2-p1s0-ce',
  'gtw-f1065-k2-p10s3-ce',
  'gtw-f1065-k2-p11s0-ce',
  'gtw-f1065-k2-p12s0-ce',
  'gtw-f1065-k2-p13s0-ce',
  'gtw-f1065-k2-header-ce',
  'gtw-f1065-k2-data-entry-ce',
  'gtw-shutdown-dst-app-ce',
  'gtw-pdf-bulk-download-ce',
  'gtw-cbc-delete-variance-data-ce',
  'gtw-retry-failed-entities-ce',
  'gtw-sync-entity-classification-ce',
  'gtw-regeneration-process-ce',
  'gtw-cbc-create-rec-data-ce',
  'gtw-rerun-pdf-generation-ce',
  'gtw-cbc-create-fs-elim-data-ce',
  'gtw-rerun-xml-generation-ce',
  'gtw-form-1118-schd-j-ce',
  'gtw-form-1118-schd-k-ce',
  'gtw-retrigger-message-ce',
  'gtw-retained-earnings-ce',
  'gtw-secondary-action-dashboard-ce',
  'gtw-all-local-chart-adjustments-ce',
  'gtw-elim-reclass-local-ce',
  'gtw-ep-adjs-local-chart-ce',
  'gtw-reclass-local-chart-ce',
  'gtw-efile-software-data-create-edit-ce',
  'gtw-efile-additional-elements-ce',
  'gtw-bulk-xml-sync-ce',
  'gtw-efile-add-edit-object-ce',
  'gtw-efile-properties-ce',
  'gtw-efile-schema-set-ce',
  'gtw-efile-data-definition-ce',
  'gtw-efile-tmef-config-ce',
  'gtw-efile-tmef-entity-map-ce',
  'gtw-efile-add-edit-diagnostics-ce',
  'gtw-efile-irs-submission-ce',
  'gtw-xml-vs-elements-ce',
  'gtw-partnership-setup-ce',
  'gtw-add-attachments-ce',
  'gtw-remove-attachments-ce',
  'gtw-dst-statements-filed-status',
  'gtw-recommended-automations-ce',
  'gtw-recommended-automations-confirm-ce',
  'gtw-summary-details-link-ce',
  'gtw-settlement-main-ce',
  'gtw-section174-adj-allocations-ce',
  'gtw-efile-batch-submission-ce',
  'gtw-efile-scrubbing-confirmation-ce',
  'gtw-efile-override-modal-ce',
  'gtw-efile-comments-modal-ce',
  'gtw-efile-create-new-scrubbing-ce',
  'gtw-efile-dashboard-popup-ce',
  'gtw-efile-req-header-elements-ce',
  'gtw-efile-ignore-modal-ce',
  'gtw-efile-ping-irs-ce',
  'gtw-efile-upload-files-ce',
  'gtw-efile-delete-form-ce',
  'gtw-efile-lock-unlock-ce',
  'gtw-section-965-adjs-ce',
  'gtw-section-965-fg-ce',
  'gtw-section-965-nov-dec-ce',
  'gtw-section-965-12-31-ce',
  'gtw-section-965-tax-db-ce',
  'gtw-adj-prior-year-data-ce',
  'gtw-gold-address-ce',
  'gtw-fir-8990-schedule-b-ce',
  'gtw-f4255-part-i-ce',
  'gtw-fir-dividends-payment-ce',
  'gtw-fir-main-trial-bal-ce',
  'gtw-fir-review-book-to-ep-ce',
  'gtw-fir-gilti-calc-grid-ce',
  'gtw-fir-gilti-consolidated-grid-ce',
  'gtw-qre-entity-details-ce',
  'gtw-qre-entity-transform-ce',
  'gtw-qre-variance-yoy-ce',
  'gtw-qre-variance-explain-ce',
  'gtw-qre-code-combination-ce',
  'gtw-qre-entity-business-ce',
  'gtw-fir-submitter-diagnostics-ce',
  'gtw-fir-diagnostic-center-ce',
  'gtw-fir-consolidation-tb-ce',
  'gtw-intercompany-diagnostics-ce',
  'gtw-data-produce-5471-ce',
  'gtw-data-produce-8858-ce',
  'gtw-est-form-ce',
  'gtw-estimate-mapping-ce',
  'gtw-estimate-posting-ce',
  'gtw-est-rollover-ce',
  'gtw-est-qtr-maintenance-ce',
  'gtw-form-review-dashboard-ce',
  'gtw-efile-add-edit-ce',
  'gtw-form4626-ce',
  'gtw-form-schedule-d-ce',
  'gtw-form8991-ce',
  'gtw-form4797-ce',
  'gtw-counter-party-ce',
  'gtw-credits-part-iii-ce',
  'gtw-form4562-ce',
  'gtw-dividends-ce',
  'gtw-trial-balance-ce',
  'gtw-k3-overrides-ce',
  'gtw-auto-tag-process-ce',
  'gtw-dst-rollover-modal-ce',
  'gtw-dst-admin-delete-modal-ce',
  'gtw-dst-form-create-edit-ce',
  'gtw-dst-view-pdf-of-efile-ce',
  'gtw-admin-job-console-list-ce',
  'gtw-change-log-job-run-details-ce',
  'gtw-admin-reset-ds-connection-ce',
  'gtw-admin-users-ce',
  'gtw-admin-validation-rule-edit-ce',
  'gtw-admin-rules-engine-supp-details-ce',
  'gtw-f965b-schedule-b-entry-ce',
  'gtw-f965b-schedule-b-audit-ce',
  'gtw-grid-builder-ce',
  'gtw-master-data-ce',
  'gtw-cache-control-ce',
  'gtw-templates-ce',
  'gtw-admin-filters-ce',
  'gtw-rules-engine-ce',
  'gtw-chart-rollover-maintenance-ce',
  'gtw-notif-engine-ce',
  'gtw-process-map-ce',
  'gtw-template-assign-ce',
  'gtw-client-ce',
  'gtw-client-save-modal-ce',
  'gtw-workflow-grid-ce',
  'gtw-summary-trial-bal-wf-ce',
  'gtw-consolidate-view-wf-ce',
  'gtw-act-sync-ftc-ce',
  'gtw-tag-sourcing-ce',
  'gtw-sync-process-ce',
  'gtw-trans-jobs-ce',
  'gtw-tbbs-reclass-ce',
  'gtw-fir-ep-drilldown-ce',
  'gtw-fir-analyze-current-taxes-ce',
  'gtw-max-loan-balance-ce',
  'gtw-fir-post86-tax-history-ce',
  'gtw-fir-post86-ep-history-ce',
  'gtw-fir-pti-summary-report-ce',
  'gtw-fir-basket-maintenance-ce',
  'gtw-fir-cfcs-with-qual-def-ce',
  'gtw-fir-cfcs-with-recap-acct-ce',
  'gtw-fir-hovering-deficit-ce',
  'gtw-fir-gtaps-common-template-ce',
  'gtw-jdc-manager-ce',
  'gtw-gold-sync-ce',
  'gtw-admin-dashboards-ce',
  'gtw-notification-ce',
  'gtw-screens-ce',
  'gtw-audit-engine-ce',
  'gtw-bizz-hier-ce',
  'gtw-entity-mgmt-app-ce',
  'gtw-limitation-screen-ce',
  'gtw-locking-ce',
  'gtw-qar-std-desc-ce',
  'gtw-form851-ce',
  'gtw-new-proforma-dashboard-ce',
  'gtw-workflow-main-ce',
  'gtw-controversy-app-ce',
  'gtw-dashboard-executive-ce',
  'gtw-form-view-ce',
  'gtw-s3-template-view-ce',
  'gtw-view-bulk-export-selection-ce',
  'gtw-alerts-ce',
  'gtw-email-settings-ce',
  'gtw-entity-chart-map-ce',
  'gtw-local-sys-chart-acct-map-ce',
  'gtw-basket-maintenance-delete-ce',
  'gtw-fir-adjust-prior-year-data-ce',
  'gtw-cbc-reporting-ce',
  'gtw-cbc-schd-a-tbl3-ce',
  'gtw-cbc-tbl2-refresh-ce',
  'gtw-cbc-cbye-refresh-ce',
  'gtw-cbc-edit-acct-tagging-ce',
  'gtw-cbc-delete-data-by-me-ce',
  'gtw-cbc-stateless-refresh-ce',
  'gtw-cbc-stateless-push-ce',
  'gtw-efile-elements-dashboard-ce',
  'gtw-efile-elements-data-ce',
  'gtw-efile-elements-grid-tpl-ce',
  'gtw-efile-elements-list-tpl-ce',
  'gtw-amend-superseded-returns-ce',
  'gtw-xml-consol-upload-ce',
  'gtw-efile-xml-sync-ce',
  'gtw-efile-submit-action-ce',
  'gtw-efile-migration-history-ce',
  'gtw-efile-submission-detail-ce',
  'gtw-efile-admin-shell-ce',
  'gtw-ftc-qar2018-ce',
  'gtw-ftc-sourcing-summary-ce',
  'gtw-messages-ce',
  'gtw-add-comment-ce',
  'gtw-grid-audit-cells-ce',
  'gtw-grid-action-modal-ce',
  'gtw-sch-p-save-ce',
  'gtw-aggregation-trigger-ce',
  'gtw-system-message-ce',
  'gtw-max-loan-bal-ho-ce',
  'gtw-switch-user-ce',
  'gtw-create-new-settings-ce',
  'gtw-system-settings-ce',
  'gtw-data-filters-ce',
  'gtw-settings-ce',
  'gtw-help-ce',
  'gtw-workspace-ce',
  'gtw-org-chart-ce',
  'gtw-client-landing-page-ce',
  'gtw-project-tagging-ce',
  'gtw-project-tag-ce',
  'gtw-tax-sensitive-acct-ce',
  'gtw-tax-cycle-workflow-ce',
  'gtw-bizz-hier-view-ce',
  'gtw-new-update-screen-ce',
  'gtw-client-backbutton-action-ce',
  'gtw-client-confirm-action-ce',
  'gtw-client-load-failed-ce',
  'gtw-confirm-issue-change-ce',
  'gtw-idle-warning-ce',
  'gtw-browser-detection-ce',
  'gtw-system-message-popup-ce',
  'gtw-error-404-ce',
  'gtw-access-denied-ce',
  'gtw-coming-soon-ce',
  'gtw-maintenance-screen-ce',
  'gtw-no-modules-page-ce',
  'gtw-workspace-not-assigned-ce',
  'gtw-add-dormat-ce',
  'gtw-remove-dormat-ce',
]);
